<div class="row d-bottom mb-5">
	<div class="col-sm-9">
		<label class="label" for="addVariant">
			{{ 'INVENTORY_PAGE.ADD_VARIANT' | translate }}
		</label>
		<ng-select
			id="addVariant"
			[multiple]="true"
			[closeOnSelect]="false"
			[searchable]="false"
			[notFoundText]="'INVENTORY_PAGE.NO_OPTIONS_LABEL' | translate"
			[placeholder]="'INVENTORY_PAGE.ADD_VARIANT' | translate"
			[(ngModel)]="editVariantCreateInput.options"
			(change)="onSelectOption($event)"
			appendTo="body"
		>
			<ng-option *ngFor="let option of optionsSelect" [value]="option">{{
				option
			}}</ng-option>
		</ng-select>
	</div>
	<div class="col-sm-3">
		<button
			class="width-100"
			status="success"
			nbButton
			(click)="onSaveVariant()"
		>
			{{ 'INVENTORY_PAGE.ADD_VARIANT' | translate }}
		</button>
	</div>
</div>
<div class="row">
	<div class="col-sm-12 variants-container">
		<button
			class="mr-2 btn-variant"
			nbButton
			*ngFor="let productVariant of variantCreateInputs"
			(click)="onVariantBtnClick(productVariant)"
		>
			<span
				class="btn-variant-icon"
				[ngClass]="{
					'variant-stored-btn': productVariant.isStored
				}"
			>
				<nb-icon icon="edit-outline"></nb-icon
			></span>
			{{ getVariantDisplayName(productVariant) }}
		</button>
	</div>
</div>
